<template>
  <div ref="layout" class="page-query">
    <TableQuery title="瓶储制票通知单修改" :tools="false" />

    <div class="table-container">
      <TableCommon
        title="批导数据"
        :custome-config="() => vxeShowCustom('xTable')"
      >
        <template #button>
          <table-button
            name="download"
            tip="模版下载"
            @click="downloadTemplate('pingchuInvoice', '瓶储制票通知单修改模版')"
          />
          <table-button
            name="import"
            tip="批导"
            @click="handleImportExcel('pingchuInvoice')"
          />
          <table-button name="save" tip="保存" @click="handleSaveImportExcel" />
        </template>
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="auto"
          max-height="440"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.gridOptions.columns"
          :data="gridOptions.gridOptions.data"
        >
          <!-- <template #toolbar /> -->
        </vxe-grid>
      </TableCommon>
    </div>
  </div>
</template>
<script>
import {
  apiExportExcelTemplate,
  apiExcelImport,
  apiGetExcelImportData
} from '@/api/common'
import { getToken } from '@/utils/auth'
import { DOWNLOAD_API } from '@/api/baseUrl'
import { savePCImprotData } from '@/api/sap/make-invoice-sap'
export default {
  data() {
    return {
      conditions: {
        templateCode: 'pingchuInvoice',
        batchNumber: ''
      },
      pagination: {
        page: 1,
        pagesize: 10000,
        totalCount: 0
      },
      loading: false,
      gridOptions: {
        buttons: [],
        gridOptions: {
          columns: [
            {
              field: 'winvo_infoid',
              title: '外部制票单号',
              width: 160
            },
            {
              field: 'invo_id',
              title: '发票号',
              width: 160
            },
            {
              field: 'manual_invo',
              title: '提货票',
              width: 160
            },
            {
              field: 'mak_date',
              title: '开票日期',
              width: 'auto'
            }
          ],
          data: []
        }
      }
    }
  },
  computed: {

  },
  methods: {
    // 模板下崽
    async downloadTemplate(type, fileName) {
      const res = await apiExportExcelTemplate(type)

      if (res?.status !== 0) {
        return
      }

      const url = `${DOWNLOAD_API()}/attachment/downFileByTmpdir.ajax?file=${
        res.data.file
      }&authToken=${getToken()}&fileName=${fileName}`
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    conditionChanged(value) {
      this.pagination = {
        page: 1,
        pagesize: 50,
        totalCount: 0
      }
    },
    // 导入excel
    async handleImportExcel(code) {
      this.conditions.templateCode = code
      // this.$refs.xTable.refreshColumn()
      this.$refs.xTable
        .readFile({
          types: ['xlsx']
        })
        .then(async resp => {
          const { files } = resp
          const formData = new FormData()
          Array.from(files).forEach(file => {
            formData.append('file', file)
          })
          const params = {
            formData,
            templateCode: this.conditions.templateCode
          }
          const res = await apiExcelImport(params)
          if (res?.status === 1) {
            this.conditions.batchNumber = res.data
            this.handleQueryImportExcel(res.data)
          }
        })
    },
    // 查询导入excel数据
    async handleQueryImportExcel() {
      const { page, pagesize } = this.pagination
      const params = { ...this.conditions, page, pagesize }
      const res = await apiGetExcelImportData(params)
      for (const item of res.data.Rows) {
        Object.keys(item).forEach(key => {
          item[this.toLineAndUp(key)] = item[key]
          delete item[key]
        })
      }
      console.log(res.data.Rows)
      this.gridOptions.gridOptions.data = res.data.Rows
    },
    // 驼峰转成下划线并且大写
    toLineAndUp(str = '') {
      return str.replace(/([A-Z])/g, '_$1').toLocaleLowerCase()
    },
    // 将导入临时表的数据保存到正式业务表
    async handleSaveImportExcel() {
      if (this.gridOptions.gridOptions.data.length) {
        const { msgtype, message } = await savePCImprotData({
          user_bp: this.$store.getters.role.USER_BP,
          data: this.gridOptions.gridOptions.data
        })
        if (msgtype === 'E') {
          this.$message.warning(message)
        } else {
          this.$message.success('保存成功!')
        }
      } else {
        this.$message.warning('没有可保存的数据！')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/views/invoice-manage/pcinvoiceImport.vue